/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Input } from "../../../components";
import toast from "react-hot-toast";
import { GeneralService } from "../../../services";
import { AuthContext } from "../../../context";
import { formatAmount, sanitizeToDecimal } from "../../../utils";

const Conversion = () => {
  const { conversion, form, onChange, submit } = useForm();
  return (
    <div className="flex items-center justify-center py-4">
      <div className="bg-white p-8 rounded-3xl shadow-sm w-full max-w-sm">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-8">
          Montos para tasa de cambio
        </h2>

        <div className="space-y-6">
          <Input
            className={{ wrapper: 'h-12', input: 'text-right' }}
            label="Dólares"
            value={1}
            onValueChange={() => {}}
            disabled
            prepend={<span>$</span>}
          />

          <Input
            className={{ wrapper: 'h-12', input: 'text-right' }}
            label="Bolívares"
            placeholder={formatAmount(conversion || 0)}
            value={form.amount}
            onValueChange={v => onChange(sanitizeToDecimal(v), 'amount')}
            prepend={<span>Bs</span>}
          />

          <div className="pt-4 flex justify-center">
            <button
              className="bg-red text-white font-bold py-3 px-12 rounded-full shadow-md hover:shadow-lg"
              onClick={submit}
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const useForm = () => {
  const INITIAL_FORM = {
    amount: '',
  };

  const { conversion, setConversion } = useContext(AuthContext);
  const [canFetch, setCanFetch] = useState(true);
  const [form, setForm] = useState({ ...INITIAL_FORM });

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const getConversion = async () => {
    try {
      const response = await GeneralService.getConversion();
      if (response.at(0)?.amount !== conversion) {
        setConversion(response[0].amount);
      }

    } catch (error) {
      onError(String(error));
    }
  }

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const isValidForm = () => {
    if (!form.amount)
      return onError('El monto es obligatorio');

    if (parseFloat(form.amount) === conversion)
      return onError('El monto debe ser distinto a la tasa actual');

    return true;
  }

  const submit = async () => {
    if (!canFetch || !isValidForm()) return;
    setCanFetch(false);

    try {
      const response = await GeneralService.createConversion({ amount: parseFloat(form.amount) });
      setConversion(response.amount);
      toast.success(`Tasa de cambio actualizada con éxito`);
      setCanFetch(true);
      return true;

    } catch (error) {
      onError(String(error));
      setCanFetch(true);
      return false;
    }
  }

  useEffect(() => {
    getConversion();
  }, []);

  return {
    conversion,
    form,
    isLoading: !canFetch,
    onChange,
    submit,
  };
}

export default Conversion